import { FC } from 'react'
import progressInitial from '@/assets/images/quiz/progress-quiz-initial.svg'
import s from './style.module.scss'

interface IProgressProps {
  finished: number
}

const Progress: FC<IProgressProps> = ({ finished = 0 }) => (
  <div className={s.progress}>
    <div className={s.progress__initial}>
      <img src={progressInitial} alt='Иконка прогресса' />
    </div>
    <div className={s.progress__active} style={{ width: `${finished}%` }}>
      <svg width='360' height='70' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M6 67.5c48-15 108.5-36 325.5-36' stroke='#FF3B5F' strokeWidth={3} />
        <path d='M6 67.5c31.009-9.69 67.234-21.885 147.5-29.303l23-1.697' stroke='#FF3B5F' strokeWidth={3} />
        <circle cx={5.5} cy={67.5} r={2.5} fill='#F5F5F5' />
        <circle cx={66.5} cy={51.5} r={4.5} fill='#F5F5F5' />
        <circle cx={33} cy={60} r={3} fill='#F5F5F5' />
        <g clipPath='url(#a)'>
          <path
            d='M338.551 36.898c-3.517 5.694-10.224 7.929-15.918 4.412-5.694-3.516-7.459-10.983-3.943-16.677 3.516-5.694 10.983-7.46 16.677-3.943 5.694 3.516 6.7 10.514 3.184 16.208Z'
            fill='#FF3B5F'
          />
          <path
            d='M335.367 20.69c-.385-.238-.778-.45-1.177-.64 4.808 3.752 6.121 10.601 2.843 15.91-3.279 5.31-9.992 7.202-15.5 4.584.349.272.715.528 1.1.766 5.694 3.517 13.161 1.751 16.677-3.943 3.517-5.694 1.751-13.16-3.943-16.677Z'
            fill='#FF3B5F'
          />
          <path
            d='m336.927 18.164-1.864-1.152a.465.465 0 0 1-.046-.758l2.802-2.247 2.298-1.841a.465.465 0 0 1 .745.46l-.618 2.88-.753 3.511a.465.465 0 0 1-.699.298l-1.865-1.151ZM321.073 43.837l1.864 1.151a.465.465 0 0 1 .047.758l-2.803 2.247-2.298 1.842a.465.465 0 0 1-.745-.46l.618-2.88.754-3.512a.464.464 0 0 1 .698-.298l1.865 1.152Z'
            fill='#FF3B5F'
          />
          <path
            d='m341.837 38.928 1.151-1.865a.465.465 0 0 1 .758-.047l2.247 2.803 1.842 2.298a.465.465 0 0 1-.46.745l-2.88-.618-3.512-.753a.465.465 0 0 1-.298-.699l1.152-1.864Z'
            fill='#FF3B5F'
          />
          <path
            d='m316.164 23.073-1.152 1.864a.465.465 0 0 1-.758.047l-2.246-2.803-1.842-2.298a.465.465 0 0 1 .46-.745l2.879.618 3.512.754a.465.465 0 0 1 .298.698l-1.151 1.865ZM325.529 16.318l-2.133.504a.464.464 0 0 1-.568-.503l.393-3.57.322-2.928a.465.465 0 0 1 .852-.201l1.599 2.473 1.951 3.016c.174.27.029.63-.283.705l-2.133.504Z'
            fill='#FF3B5F'
          />
          <path
            d='m332.471 45.682 2.133-.504a.465.465 0 0 1 .569.503l-.393 3.57-.323 2.928a.465.465 0 0 1-.852.201l-1.599-2.472-1.951-3.017a.465.465 0 0 1 .284-.704l2.132-.505ZM343.683 27.529l-.505-2.133a.465.465 0 0 1 .503-.569l3.571.394 2.927.322a.464.464 0 0 1 .201.852l-2.472 1.6-3.017 1.95a.464.464 0 0 1-.704-.283l-.504-2.133Z'
            fill='#FF3B5F'
          />
          <path
            d='m314.318 34.471.504 2.133a.465.465 0 0 1-.503.569l-3.571-.394-2.927-.322a.465.465 0 0 1-.201-.852l2.473-1.6 3.016-1.95a.465.465 0 0 1 .705.284l.504 2.132Z'
            fill='#FF3B5F'
          />
        </g>
        <g clipPath='url(#b)'>
          <path
            d='M7.531 68c0 1.509-1.022 2.732-2.53 2.732a2.732 2.732 0 1 1 0-5.464c1.508 0 2.53 1.223 2.53 2.732Z'
            fill='#FF3B5F'
          />
          <path
            d='M5 65.268a2.76 2.76 0 0 0-.302.016 2.733 2.733 0 0 1 0 5.432A2.732 2.732 0 1 0 5 65.268Z'
            fill='#FF3B5F'
          />
        </g>
        <g clipPath='url(#c)'>
          <path
            d='M36.037 60c0 1.81-1.226 3.279-3.037 3.279a3.279 3.279 0 0 1 0-6.558c1.81 0 3.037 1.468 3.037 3.279Z'
            fill='#FF3B5F'
          />
          <path
            d='M33 56.721c-.122 0-.243.007-.362.02a3.28 3.28 0 0 1 0 6.518A3.279 3.279 0 1 0 33 56.72Z'
            fill='#FF3B5F'
          />
          <path
            d='M33 55.918h-.593a.126.126 0 0 1-.118-.168l.325-.916.268-.75a.126.126 0 0 1 .236 0l.268.75.325.916a.126.126 0 0 1-.118.168H33Z'
            fill='url(#d)'
          />
          <path
            d='M33 64.082h.593c.087 0 .148.086.118.168l-.325.916-.268.75a.126.126 0 0 1-.236 0l-.267-.75-.326-.916a.126.126 0 0 1 .118-.168H33Z'
            fill='url(#e)'
          />
          <path
            d='M37.082 60v-.593c0-.087.086-.147.168-.118l.916.325.75.268a.126.126 0 0 1 0 .236l-.75.268-.916.325a.126.126 0 0 1-.168-.118V60Z'
            fill='url(#f)'
          />
          <path
            d='M28.918 60v.593a.126.126 0 0 1-.168.118l-.916-.325-.75-.268a.126.126 0 0 1 0-.236l.75-.267.916-.326a.126.126 0 0 1 .168.118V60Z'
            fill='url(#g)'
          />
          <path
            d='m30.113 57.114-.419.419a.126.126 0 0 1-.202-.035l-.417-.878-.342-.72a.126.126 0 0 1 .167-.167l.72.342.878.417a.126.126 0 0 1 .035.202l-.42.42Z'
            fill='url(#h)'
          />
          <path
            d='m35.887 62.887.419-.42a.126.126 0 0 1 .202.035l.417.878.342.72a.126.126 0 0 1-.167.167l-.72-.342-.878-.417a.126.126 0 0 1-.035-.202l.42-.42Z'
            fill='url(#i)'
          />
          <path
            d='m35.887 57.114-.42-.42a.126.126 0 0 1 .035-.202l.878-.417.72-.342c.107-.051.218.06.167.167l-.342.72-.417.878a.126.126 0 0 1-.202.035l-.42-.42Z'
            fill='url(#j)'
          />
          <path
            d='m30.113 62.886.42.42a.126.126 0 0 1-.035.202l-.878.417-.72.342a.126.126 0 0 1-.167-.167l.341-.72.418-.878a.126.126 0 0 1 .202-.035l.42.42Z'
            fill='url(#k)'
          />
        </g>
        <g clipPath='url(#l)'>
          <path
            d='M70.532 51.47c-.28 2.701-2.337 4.702-5.039 4.422a4.918 4.918 0 0 1 1.014-9.784c2.702.28 4.305 2.66 4.025 5.362Z'
            fill='#FF3B5F'
          />
          <path
            d='M66.507 46.108a4.982 4.982 0 0 0-.543-.026 4.919 4.919 0 0 1-1.008 9.724 4.918 4.918 0 1 0 1.551-9.698Z'
            fill='#FF3B5F'
          />
          <path
            d='m66.631 44.91-.884-.092a.189.189 0 0 1-.151-.27l.628-1.315.514-1.079a.189.189 0 0 1 .354.037l.282 1.161.345 1.417a.189.189 0 0 1-.203.232l-.885-.092Z'
            fill='url(#m)'
          />
          <path
            d='m65.369 57.09.885.092c.13.014.206.151.15.27l-.627 1.315-.515 1.079a.189.189 0 0 1-.354-.037l-.282-1.161-.345-1.417a.189.189 0 0 1 .203-.232l.885.092Z'
            fill='url(#n)'
          />
          <path
            d='m72.09 51.631.092-.884a.189.189 0 0 1 .27-.151l1.315.628 1.079.514a.189.189 0 0 1-.037.354l-1.161.282-1.417.345a.189.189 0 0 1-.232-.203l.092-.885Z'
            fill='url(#o)'
          />
          <path
            d='m59.91 50.369-.092.885a.189.189 0 0 1-.269.15l-1.316-.628-1.079-.514a.189.189 0 0 1 .037-.354l1.161-.282 1.417-.345a.189.189 0 0 1 .232.203l-.091.885Z'
            fill='url(#p)'
          />
          <path
            d='m62.14 46.247-.69.56a.188.188 0 0 1-.297-.083l-.487-1.374-.399-1.127a.189.189 0 0 1 .276-.224l1.02.621 1.246.759a.189.189 0 0 1 .021.307l-.69.56Z'
            fill='url(#q)'
          />
          <path
            d='m69.86 55.753.69-.56a.189.189 0 0 1 .297.083l.487 1.374.399 1.127a.189.189 0 0 1-.276.224l-1.021-.622-1.245-.758a.189.189 0 0 1-.021-.307l.69-.561Z'
            fill='url(#r)'
          />
          <path
            d='m70.753 47.14-.56-.69a.189.189 0 0 1 .083-.297l1.374-.487 1.127-.399a.189.189 0 0 1 .224.276l-.622 1.02-.758 1.246a.189.189 0 0 1-.307.021l-.56-.69Z'
            fill='url(#s)'
          />
          <path
            d='m61.247 54.86.56.69a.189.189 0 0 1-.083.297l-1.374.487-1.127.399a.189.189 0 0 1-.224-.276l.622-1.021.758-1.245a.189.189 0 0 1 .307-.021l.561.69Z'
            fill='url(#t)'
          />
        </g>
        <g clipPath='url(#u)'>
          <path
            d='M111.484 44.965c-.575 3.27-3.256 5.53-6.526 4.955a6.01 6.01 0 0 1 2.083-11.84c3.27.575 5.018 3.615 4.443 6.885Z'
            fill='#FF3B5F'
          />
          <path
            d='M107.041 38.08a6.043 6.043 0 0 0-.66-.079 6.011 6.011 0 0 1-2.07 11.768 6.011 6.011 0 1 0 2.73-11.689Z'
            fill='#FF3B5F'
          />
          <path
            d='m107.297 36.63-1.071-.19a.23.23 0 0 1-.161-.34l.88-1.55.72-1.27a.23.23 0 0 1 .428.075l.244 1.44.297 1.757a.23.23 0 0 1-.267.266l-1.07-.189Z'
            fill='url(#v)'
          />
          <path
            d='m104.703 51.37 1.071.19a.23.23 0 0 1 .16.34l-.879 1.55-.721 1.27a.23.23 0 0 1-.427-.075l-.244-1.44-.298-1.757a.23.23 0 0 1 .267-.266l1.071.189Z'
            fill='url(#w)'
          />
          <path
            d='m113.371 45.297.188-1.07a.23.23 0 0 1 .341-.161l1.55.879 1.27.72a.23.23 0 0 1-.075.428l-1.44.244-1.757.298a.231.231 0 0 1-.266-.268l.189-1.07Z'
            fill='url(#x)'
          />
          <path
            d='m98.63 42.703-.19 1.07a.23.23 0 0 1-.34.161l-1.55-.879-1.27-.72a.23.23 0 0 1 .075-.428l1.44-.244 1.757-.298a.23.23 0 0 1 .265.268l-.188 1.07Z'
            fill='url(#y)'
          />
          <path
            d='m101.705 37.871-.89.624a.231.231 0 0 1-.355-.127l-.474-1.718-.389-1.408a.23.23 0 0 1 .356-.25l1.191.847 1.452 1.032a.23.23 0 0 1-.001.376l-.89.624Z'
            fill='url(#z)'
          />
          <path
            d='m110.295 50.129.89-.624a.231.231 0 0 1 .355.127l.474 1.718.389 1.408a.23.23 0 0 1-.356.25l-1.191-.847-1.453-1.032a.23.23 0 0 1 .002-.376l.89-.624Z'
            fill='url(#A)'
          />
          <path
            d='m112.129 39.705-.624-.89a.23.23 0 0 1 .127-.355l1.718-.474 1.408-.389a.23.23 0 0 1 .249.356l-.846 1.19-1.032 1.453a.23.23 0 0 1-.376 0l-.624-.891Z'
            fill='url(#B)'
          />
          <path
            d='m99.871 48.295.624.89a.23.23 0 0 1-.128.355l-1.717.474-1.408.389a.23.23 0 0 1-.25-.356l.846-1.19 1.033-1.453a.23.23 0 0 1 .376 0l.624.891Z'
            fill='url(#C)'
          />
        </g>
        <g clipPath='url(#D)'>
          <path
            d='M157.412 39.907c-1.085 3.77-4.518 6.092-8.289 5.007a7.105 7.105 0 0 1 3.928-13.654c3.771 1.085 5.445 4.876 4.361 8.646Z'
            fill='#FF3B5F'
          />
          <path
            d='M153.051 31.26a7.187 7.187 0 0 0-.766-.175 7.104 7.104 0 0 1-3.904 13.57 7.103 7.103 0 1 0 4.67-13.395Z'
            fill='#FF3B5F'
          />
          <path
            d='m153.532 29.587-1.234-.355a.272.272 0 0 1-.146-.42l1.226-1.712 1.006-1.403a.273.273 0 0 1 .494.142l.106 1.723.13 2.102a.272.272 0 0 1-.347.278l-1.235-.355Z'
            fill='url(#E)'
          />
          <path
            d='m148.642 46.587 1.235.355a.273.273 0 0 1 .146.421l-1.227 1.712-1.006 1.403a.272.272 0 0 1-.493-.142l-.107-1.723-.13-2.102a.272.272 0 0 1 .347-.279l1.235.355Z'
            fill='url(#F)'
          />
          <path
            d='m159.587 40.532.355-1.234a.273.273 0 0 1 .421-.146l1.712 1.227 1.403 1.006a.273.273 0 0 1-.142.493l-1.723.106-2.102.13a.273.273 0 0 1-.279-.347l.355-1.235Z'
            fill='url(#G)'
          />
          <path
            d='m142.587 35.642-.355 1.235a.272.272 0 0 1-.42.146l-1.712-1.227-1.403-1.006a.272.272 0 0 1 .142-.493l1.723-.107 2.102-.13a.272.272 0 0 1 .278.347l-.355 1.235Z'
            fill='url(#H)'
          />
          <path
            d='m146.806 30.348-1.124.622a.273.273 0 0 1-.401-.194l-.343-2.078-.281-1.703a.273.273 0 0 1 .45-.249l1.293 1.143 1.579 1.394a.272.272 0 0 1-.049.443l-1.124.622Z'
            fill='url(#I)'
          />
          <path
            d='m155.368 45.827 1.125-.622a.272.272 0 0 1 .4.194l.343 2.078.281 1.703a.272.272 0 0 1-.449.248l-1.294-1.143-1.578-1.394a.273.273 0 0 1 .048-.442l1.124-.622Z'
            fill='url(#J)'
          />
          <path
            d='m158.827 33.806-.622-1.124a.272.272 0 0 1 .194-.401l2.078-.343 1.703-.28a.272.272 0 0 1 .248.449l-1.143 1.294-1.394 1.578a.273.273 0 0 1-.443-.049l-.621-1.124Z'
            fill='url(#K)'
          />
          <path
            d='m143.348 42.369.622 1.124a.272.272 0 0 1-.194.4l-2.078.343-1.703.281a.273.273 0 0 1-.249-.45l1.143-1.293 1.394-1.578a.273.273 0 0 1 .443.048l.622 1.125Z'
            fill='url(#L)'
          />
        </g>
        <g clipPath='url(#M)'>
          <path
            d='M210.46 37.301c-1.916 4.395-6.447 6.66-10.842 4.745a8.682 8.682 0 0 1 6.938-15.917c4.396 1.916 5.82 6.777 3.904 11.172Z'
            fill='#FF3B5F'
          />
          <path
            d='M206.556 26.129a8.696 8.696 0 0 0-.9-.335 8.683 8.683 0 0 1-6.896 15.82 8.682 8.682 0 1 0 7.796-15.485Z'
            fill='#FF3B5F'
          />
          <path
            d='m207.406 24.178-1.439-.627a.333.333 0 0 1-.11-.533l1.76-1.878 1.443-1.54a.333.333 0 0 1 .575.252l-.146 2.104-.178 2.568a.333.333 0 0 1-.465.282l-1.44-.628Z'
            fill='url(#N)'
          />
          <path
            d='m198.768 43.996 1.439.627a.333.333 0 0 1 .11.533l-1.76 1.878-1.442 1.54a.333.333 0 0 1-.575-.25l.145-2.106.178-2.567a.334.334 0 0 1 .466-.282l1.439.627Z'
            fill='url(#O)'
          />
          <path
            d='m212.996 38.407.627-1.44a.333.333 0 0 1 .533-.11l1.878 1.76 1.54 1.443a.333.333 0 0 1-.251.575l-2.105-.146-2.567-.178a.333.333 0 0 1-.282-.465l.627-1.44Z'
            fill='url(#P)'
          />
          <path
            d='m193.178 29.768-.627 1.44a.333.333 0 0 1-.533.11l-1.878-1.76-1.539-1.443a.333.333 0 0 1 .25-.575l2.105.146 2.568.177a.333.333 0 0 1 .282.466l-.628 1.44Z'
            fill='url(#Q)'
          />
          <path
            d='m199.135 24.026-1.462.575a.332.332 0 0 1-.454-.3l-.084-2.572-.068-2.108a.333.333 0 0 1 .584-.23l1.385 1.592 1.69 1.94a.333.333 0 0 1-.13.53l-1.461.573Z'
            fill='url(#R)'
          />
          <path
            d='m207.04 44.148 1.461-.574a.332.332 0 0 1 .454.3l.084 2.571.069 2.109a.333.333 0 0 1-.584.23l-1.386-1.592-1.689-1.941a.333.333 0 0 1 .129-.529l1.462-.574Z'
            fill='url(#S)'
          />
          <path
            d='m213.148 30.135-.574-1.461a.333.333 0 0 1 .299-.455l2.572-.084 2.109-.068a.333.333 0 0 1 .229.584l-1.591 1.385-1.941 1.69a.333.333 0 0 1-.529-.13l-.574-1.461Z'
            fill='url(#T)'
          />
          <path
            d='m193.026 38.04.575 1.461a.333.333 0 0 1-.3.455l-2.572.083-2.109.069a.333.333 0 0 1-.229-.584l1.591-1.386 1.942-1.69a.333.333 0 0 1 .528.13l.574 1.462Z'
            fill='url(#U)'
          />
        </g>
        <g clipPath='url(#V)'>
          <path
            d='M271.937 35.654c-2.434 5.584-8.19 8.462-13.775 6.028-5.584-2.434-8.138-8.935-5.704-14.52 2.435-5.584 8.935-8.138 14.52-5.703 5.585 2.434 7.394 8.61 4.959 14.195Z'
            fill='#FF3B5F'
          />
          <path
            d='M266.978 21.459a11.112 11.112 0 0 0-1.144-.426c4.817 2.762 6.884 8.764 4.614 13.971-2.27 5.207-8.074 7.779-13.375 6.13.349.2.712.383 1.09.548 5.584 2.434 12.085-.12 14.519-5.704 2.434-5.585-.119-12.085-5.704-14.52Z'
            fill='#FF3B5F'
          />
          <path
            d='m268.058 18.98-1.828-.796a.423.423 0 0 1-.14-.677l2.236-2.386 1.833-1.956a.423.423 0 0 1 .73.318l-.185 2.674-.226 3.262a.423.423 0 0 1-.591.359l-1.829-.797Z'
            fill='url(#W)'
          />
          <path
            d='m257.083 44.16 1.828.797c.268.117.34.464.14.677l-2.236 2.386-1.833 1.956a.423.423 0 0 1-.731-.318l.186-2.674.226-3.263a.423.423 0 0 1 .591-.358l1.829.797Z'
            fill='url(#X)'
          />
          <path
            d='m275.16 37.058.797-1.828a.423.423 0 0 1 .677-.14l2.386 2.236 1.956 1.833a.423.423 0 0 1-.318.73l-2.675-.185-3.262-.226a.423.423 0 0 1-.358-.591l.797-1.829Z'
            fill='url(#Y)'
          />
          <path
            d='m249.981 26.083-.797 1.828a.424.424 0 0 1-.678.14l-2.386-2.236-1.956-1.833a.423.423 0 0 1 .319-.73l2.674.185 3.262.226c.292.02.476.323.359.59l-.797 1.83Z'
            fill='url(#Z)'
          />
          <path
            d='m257.549 18.788-1.857.73a.424.424 0 0 1-.578-.38l-.106-3.269-.087-2.68a.423.423 0 0 1 .742-.29l1.76 2.021 2.147 2.467a.423.423 0 0 1-.164.671l-1.857.73Z'
            fill='url(#aa)'
          />
          <path
            d='m267.592 44.353 1.857-.73a.423.423 0 0 1 .577.38l.107 3.269.087 2.68a.423.423 0 0 1-.742.29l-1.76-2.021-2.147-2.467a.423.423 0 0 1 .164-.671l1.857-.73Z'
            fill='url(#ab)'
          />
          <path
            d='m275.353 26.549-.729-1.857a.423.423 0 0 1 .38-.578l3.268-.106 2.679-.087a.423.423 0 0 1 .292.742l-2.022 1.76-2.467 2.147a.422.422 0 0 1-.671-.164l-.73-1.857Z'
            fill='url(#ac)'
          />
          <path
            d='m249.788 36.592.729 1.857a.423.423 0 0 1-.38.577l-3.268.106-2.679.087a.423.423 0 0 1-.292-.742l2.022-1.76 2.467-2.146a.423.423 0 0 1 .671.164l.73 1.857Z'
            fill='url(#ad)'
          />
        </g>
        <defs>
          <radialGradient
            id='d'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .95893 -.7188 0 33 54.959)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='e'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .95893 -.7188 0 33 65.041)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='f'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .7188 -.95893 0 38.041 60)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='g'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .7188 -.95893 0 27.959 60)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='h'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .92478 -.92478 0 29.645 56.645)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='i'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .92478 -.92478 0 36.355 63.355)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='j'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .92478 -.92478 0 36.355 56.645)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='k'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(0 .92478 -.92478 0 29.645 63.355)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.396} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='m'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.14829 1.43073 -1.07247 -.11115 66.78 43.479)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='n'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.14829 1.43073 -1.07246 -.11115 65.22 58.521)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='o'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.11115 1.07247 -1.43073 -.14829 73.522 51.78)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='p'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.11115 1.07246 -1.43073 -.14829 58.479 50.22)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='q'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(95.917 10.254 50.471) scale(1.38718)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='r'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.143 1.37979 -1.37978 -.143 70.487 56.525)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='s'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(95.917 14.792 55.504) scale(1.38718)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='t'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(95.917 5.221 55.01) scale(1.38718)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={0.729} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='v'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.30462 1.73144 -1.29788 -.22834 107.601 34.898)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='w'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 29.912 70.369) scale(1.75803 1.3178)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='x'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.22834 1.29788 -1.73144 -.30462 115.102 45.601)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='y'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 30.654 61.868) scale(1.3178 1.75803)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='z'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 35.027 60.832) scale(1.69544)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='A'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 34.039 72.147) scale(1.69544 1.69543)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='B'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 40.19 66.983) scale(1.69544)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='C'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(99.978 28.875 65.996) scale(1.69544)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id='E'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(106.049 66.667 71.808) scale(2.07767 1.55741)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='F'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.5744 1.9967 -1.4967 -.43056 148.068 48.584)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='G'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(106.049 65.318 81.38) scale(1.55741 2.07767)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='H'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.43056 1.4967 -1.9967 -.5744 140.591 35.068)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='I'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(106.049 62.104 69.548) scale(2.0037)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='J'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.55394 1.9256 -1.9256 -.55394 156.064 47.083)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='K'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(106.049 67.577 76.817) scale(2.0037)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='L'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(106.049 54.834 75.02) scale(2.0037)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='N'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 97.055 79.181) scale(2.53917 1.90335)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='O'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-1.0146 2.32765 -1.74478 -.76053 197.753 46.324)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='P'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 94.752 90.227) scale(1.90335 2.53917)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='Q'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.76053 1.74478 -2.32765 -1.0146 190.851 28.753)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='R'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 91.913 76.201) scale(2.44877)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='S'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 88.848 90.904) scale(2.44877 2.44876)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='T'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 97.732 85.085) scale(2.44877)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='U'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 83.029 82.02) scale(2.44877)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='W'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-1.2891 2.95739 -2.21684 -.9663 269.347 16.023)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='X'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 112.466 107.328) scale(3.22613 2.41827)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='Y'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-.9663 2.21684 -2.95739 -1.2891 278.117 38.347)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='Z'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 115.392 93.294) scale(2.41827 3.22613)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='aa'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 122.893 92.434) scale(3.11127)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='ab'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='matrix(-1.2432 2.8521 -2.85209 -1.2432 268.407 46.428)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='ac'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 130.287 103.722) scale(3.11127)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <radialGradient
            id='ad'
            cx={0}
            cy={0}
            r={1}
            gradientUnits='userSpaceOnUse'
            gradientTransform='rotate(113.552 111.605 99.827) scale(3.11127)'
          >
            <stop stopColor='#FF3B5F' />
            <stop offset={1} stopColor='#FF3B5F' stopOpacity={0.33} />
          </radialGradient>
          <clipPath id='a'>
            <path fill='#fff' transform='rotate(31.698 160.045 566.972)' d='M0 0h44.35v44.35H0z' />
          </clipPath>
          <clipPath id='b'>
            <path fill='#fff' transform='translate(0 63)' d='M0 0h10v6H0z' />
          </clipPath>
          <clipPath id='c'>
            <path fill='#fff' transform='translate(27 54)' d='M0 0h12v12H0z' />
          </clipPath>
          <clipPath id='l'>
            <path fill='#fff' transform='rotate(5.917 -368.818 581.432)' d='M0 0h18v18H0z' />
          </clipPath>
          <clipPath id='u'>
            <path fill='#fff' transform='rotate(9.978 -130.511 571.623)' d='M0 0h22v22H0z' />
          </clipPath>
          <clipPath id='D'>
            <path fill='#fff' transform='rotate(16.049 -6.934 515.305)' d='M0 0h26v26H0z' />
          </clipPath>
          <clipPath id='M'>
            <path fill='#fff' transform='rotate(23.552 65.839 473.955)' d='M0 0h31.775v31.775H0z' />
          </clipPath>
          <clipPath id='V'>
            <path fill='#fff' transform='rotate(23.552 114.074 607.196)' d='M0 0h40.372v40.372H0z' />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
)

export default Progress
